import serviceClient from "./serviceClient";

// General post request handler
const postRequest = async (url, data) => {
  try {
    const { data: responseData } = await serviceClient.post(url, data);
    return responseData;
  } catch (error) {
    console.error(`API Error (${url}):`, error);
    throw error.response?.data || { message: "An unexpected error occurred." };
  }
};

export const login = (loginData) => postRequest("/auth/login", loginData);

export const logout = () =>
  Promise.resolve({
    status: true,
    message: "Logged out successfully",
  });
